import axios, { AxiosRequestConfig } from 'axios';
// config
import { API_URL } from 'config-global';
import { signout } from 'store/reducers/auth';
import { store } from 'store';
import { snackbar } from 'utils/alert';
// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: API_URL });

axiosInstance.interceptors.request.use(
  (config: any) => {
    config.baseURL = API_URL;
    const state = store.getState() as any;
    const accessToken = state.auth.token;
    if (accessToken) {
      config.headers['x-auth-token'] = accessToken;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && response.status === 400) {
      snackbar.error(response.data);
    } else if (response && response.status === 401) {
      snackbar.error('You have to login');
      store.dispatch(signout());
    } else if (response && response.status === 402) {
      snackbar.warning(response.data);
    } else if (response && response.status === 429) {
      snackbar.error(response.data);
    } else {
      console.log(response);
    }
  }
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

